import Vue from 'vue'
import Vuex from 'vuex'

import keyModule from './modules/key';
import messageModule from './modules/messages';
import tabsModule from './modules/tabs';
import imageCacherModule from './modules/imageCacher';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {
        // called at boot to reload state from localstorage
        init(store, force = false) {
            console.log('reloadState', force);
        },
    },
    modules: {
        key: keyModule,
        globalMessages: messageModule,
        imC: imageCacherModule,
        tabs: tabsModule
    }
})
